import { useRef, useEffect } from "react";
export const useScrollEffect = ({ stickyElementRef, scrollableElementRef, containerRef, initialOffset, isEnabled = true, }) => {
    const lastScrollTop = useRef(0);
    const initialPositionSet = useRef(false);
    const isScrolledOver = useRef(false);
    useEffect(() => {
        if (!isEnabled)
            return;
        const updateElementPosition = () => {
            const scrollPosition = window.scrollY || document.documentElement.scrollTop;
            const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
            const triggerPosition = totalHeight * 0.5;
            if (!initialPositionSet.current && scrollableElementRef.current) {
                scrollableElementRef.current.style.transform = `translateY(${initialOffset})`;
                initialPositionSet.current = true;
            }
            if (scrollPosition > triggerPosition &&
                scrollableElementRef.current &&
                stickyElementRef.current &&
                containerRef.current) {
                const deltaScroll = scrollPosition - lastScrollTop.current;
                const currentTransform = parseFloat(scrollableElementRef.current.style.transform
                    .replace("translateY(", "")
                    .replace("%", "")
                    .replace(")", "")) || 100;
                let newTransform = currentTransform - (deltaScroll / window.innerHeight) * 350;
                newTransform = Math.max(Math.min(newTransform, 100), -100);
                if (!isScrolledOver.current) {
                    scrollableElementRef.current.style.transform = `translateY(${newTransform}%)`;
                }
                if (newTransform === -100) {
                    isScrolledOver.current = true;
                }
                const newHeight = 275 + (250 * (newTransform + 100)) / 200;
                containerRef.current.style.height = `${newHeight}px`;
            }
            else if (scrollPosition <= triggerPosition &&
                scrollableElementRef.current &&
                containerRef.current &&
                scrollableElementRef.current.style.transform !== "translateY(100%)") {
                isScrolledOver.current = false;
                const deltaScroll = scrollPosition - lastScrollTop.current;
                const currentTransform = parseFloat(scrollableElementRef.current.style.transform
                    .replace("translateY(", "")
                    .replace("%", "")
                    .replace(")", "")) || 100;
                const newTransform = currentTransform - (deltaScroll / window.innerHeight) * 170;
                scrollableElementRef.current.style.transform = `translateY(${newTransform}%)`;
            }
            lastScrollTop.current = scrollPosition;
        };
        updateElementPosition();
        window.addEventListener("scroll", updateElementPosition);
        return () => {
            window.removeEventListener("scroll", updateElementPosition);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
